import { ViewAggregationType } from '@baserow/modules/database/viewAggregationTypes'
import { FormulaFieldType } from '@baserow/modules/database/fieldTypes'

import BateriaAggregation from '@extras_mg/components/BateriaAggregation'

/**
 * La "batería" de Monday como resumen de columna.
 *
 * Monday pone abajo de cada tablero una barra partida en colores que dice cómo
 * está repartida la columna de estado. Baserow ya calcula ese dato —su
 * agregación `distribution` devuelve cuántas filas hay por valor—, pero lo pinta
 * como una lista de textos. Esto es el mismo dato dibujado como barra.
 *
 * `getRawType()` devuelve 'distribution' a propósito: así el servidor no
 * necesita saber nada de esto, calcula lo de siempre y el cambio vive entero en
 * el navegador.
 *
 * También va en el resumen de cada grupo, como en Monday. El core sólo calcula
 * por grupo totales que son un número suelto; para selección única y casilla el
 * plugin del backend agrega por grupo la misma distribución
 * (extras_mg/resumen_por_grupo.py). En otros tipos de campo el grupo queda sin
 * barra, como antes.
 */
export class BateriaViewAggregationType extends ViewAggregationType {
  static getType() {
    return 'mg_bateria'
  }

  getRawType() {
    return 'distribution'
  }

  getName() {
    return 'Barra de distribución'
  }

  getShortName() {
    return 'Barra'
  }

  getCompatibleFieldTypes() {
    return [
      'single_select',
      'boolean',
      'text',
      'url',
      'email',
      'phone_number',
      'rating',
      FormulaFieldType.compatibleWithFormulaTypes('text', 'char', 'boolean'),
    ]
  }

  getComponent() {
    return BateriaAggregation
  }

  isAllowedInGroupBy() {
    return true
  }

  getOrder() {
    // Arriba en el menú: es la que se quiere casi siempre en una columna de
    // estado, que es de lo que va este tablero.
    return 10
  }

  getValue(value, context) {
    // El componente necesita los pares [valor, conteo] tal cual llegan; el
    // porcentaje lo calcula él, que es quien sabe cuánto espacio tiene.
    return value
  }
}
